import React, { useEffect, useRef, useState } from 'react';
import { whatsappLinkProps, GENERAL_ORDER_MESSAGE } from '../lib/whatsapp';

const NavLogo = () => (
  <a href="#home" aria-label="Maison Vael — home" style={{ textDecoration: 'none' }}>
    <div style={{ lineHeight: 1 }}>
      <div style={{ fontFamily: 'Tenor Sans', fontStyle: 'normal', fontSize: '11px', letterSpacing: '5px', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '3px' }}>
        MAISON
      </div>
      <div style={{ fontFamily: 'Cinzel', fontStyle: 'normal', fontSize: '20px', letterSpacing: '6px', color: 'var(--cream)', fontWeight: 400 }}>
        VAEL
      </div>
    </div>
  </a>
);

const Navbar = () => {
  const navRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { href: '#collection', label: 'Collection' },
    { href: '#story', label: 'Story' },
    { href: '#why', label: 'Why Vael' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <>
      <nav
        data-testid="navbar"
        ref={navRef}
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500,
          padding: '20px 48px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          transition: 'background 0.5s ease, padding 0.4s ease, backdrop-filter 0.5s ease',
          background: scrolled ? 'rgba(10,10,8,0.85)' : 'transparent',
          backdropFilter: scrolled ? 'blur(20px)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(201,169,110,0.08)' : '1px solid transparent',
        }}
      >
        <NavLogo />

        {/* Desktop nav links */}
        <div className="hidden md:flex items-center gap-10">
          {links.map(l => (
            <a key={l.href} href={l.href} className="nav-link"
              data-testid={`nav-link-${l.label.toLowerCase().replace(' ', '-')}`}>
              {l.label}
            </a>
          ))}
        </div>

        {/* Shop CTA — straight to WhatsApp, the live order channel */}
        <div className="hidden md:block">
          <a
            {...whatsappLinkProps(GENERAL_ORDER_MESSAGE)}
            className="btn-gold"
            data-testid="navbar-shop-btn"
            aria-label="Order via WhatsApp"
            style={{ padding: '10px 24px', fontSize: '10px' }}
          >
            Order Now
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden"
          onClick={() => setMenuOpen(v => !v)}
          data-testid="hamburger-btn"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}
        >
          <span style={{ display: 'block', width: '24px', height: '1px', background: menuOpen ? 'var(--gold)' : 'var(--cream)', transition: 'transform 0.3s ease, background 0.3s ease', transform: menuOpen ? 'translateY(6px) rotate(45deg)' : 'none' }} />
          <span style={{ display: 'block', width: '24px', height: '1px', background: menuOpen ? 'var(--gold)' : 'var(--cream)', transition: 'opacity 0.3s ease', opacity: menuOpen ? 0 : 1 }} />
          <span style={{ display: 'block', width: '24px', height: '1px', background: menuOpen ? 'var(--gold)' : 'var(--cream)', transition: 'transform 0.3s ease, background 0.3s ease', transform: menuOpen ? 'translateY(-6px) rotate(-45deg)' : 'none' }} />
        </button>
      </nav>

      {/* Mobile full-screen overlay. `visibility: hidden` also removes the
          links from the tab order while closed — don't swap it for opacity. */}
      <div
        id="mobile-menu"
        data-testid="mobile-menu"
        className="mobile-menu"
        aria-hidden={!menuOpen}
        style={{
          position: 'fixed', inset: 0, zIndex: 499,
          background: 'rgba(10,10,8,0.97)',
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          gap: '40px',
          opacity: menuOpen ? 1 : 0,
          visibility: menuOpen ? 'visible' : 'hidden',
        }}
      >
        {links.map(l => (
          <a
            key={l.href}
            href={l.href}
            onClick={() => setMenuOpen(false)}
            className="mobile-menu-link"
          >
            {l.label}
          </a>
        ))}
        <a
          {...whatsappLinkProps(GENERAL_ORDER_MESSAGE)}
          onClick={() => setMenuOpen(false)}
          className="btn-gold"
          data-testid="mobile-order-btn"
          aria-label="Order via WhatsApp"
          style={{ marginTop: '20px' }}
        >
          Order Now
        </a>
      </div>
    </>
  );
};

export default Navbar;
